import React, { createContext, useState, useContext, useEffect } from 'react';

const EditModeContext = createContext();

export const EditModeProvider = ({ children }) => {
  const [editMode, setEditMode] = useState(() => {
    return localStorage.getItem('pageEditMode') === 'true';
  });

  const toggleEditMode = () => {
    const newMode = !editMode;
    setEditMode(newMode);
    localStorage.setItem('pageEditMode', newMode);
  };

  return (
    <EditModeContext.Provider value={{ editMode, setEditMode, toggleEditMode }}>
      {children}
    </EditModeContext.Provider>
  );
};

export const useEditMode = () => {
  const context = useContext(EditModeContext);
  if (!context) {
    throw new Error('useEditMode must be used within EditModeProvider');
  }
  return context;
};

// Editable Section Component
export const EditableSection = ({ 
  sectionId, 
  pageName, 
  children, 
  onAddDropdown, 
  onEditContent,
  className = ""
}) => {
  const { editMode } = useEditMode();
  const [showMenu, setShowMenu] = useState(false);

  if (!editMode) {
    return <div className={className}>{children}</div>;
  }

  return (
    <div 
      className={`${className} relative group`}
      onMouseEnter={() => setShowMenu(true)}
      onMouseLeave={() => setShowMenu(false)}
      style={{
        outline: editMode ? '2px dashed #f59e0b' : 'none',
        outlineOffset: '4px'
      }}
    >
      {showMenu && (
        <div className="absolute top-0 right-0 bg-orange-600 text-white px-3 py-1 rounded-bl text-xs z-50 flex gap-2">
          <button
            onClick={() => onAddDropdown && onAddDropdown(sectionId)}
            className="hover:bg-orange-700 px-2 py-1 rounded"
            title="Add dropdown here"
          >
            📋 + Dropdown
          </button>
          <button
            onClick={() => onEditContent && onEditContent(sectionId)}
            className="hover:bg-orange-700 px-2 py-1 rounded"
            title="Edit this section"
          >
            ✏️ Edit
          </button>
        </div>
      )}
      {children}
    </div>
  );
};
